import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { ClaimTextField } from '../fields';

export const Box30_ReservedNUCC30: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">30. Rsvd for NUCC</Typography>
      <Controller
        name="reservedNUCC30"
        control={control}
        render={({ field, fieldState }) => (
          <ClaimTextField
            field={field}
            fieldState={fieldState}
            size="small"
            fullWidth
            disabled
          />
        )}
      />
    </>
  );
};